export default __webpack_public_path__ + "static/media/badge_inside.53f6b577.png";